<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span">{{ 'aumico_templates_switch_accounts_dialog_title' | i18next }} </span>
    </div>
    <div class="seprator"></div>
    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>
<div mat-dialog-content>
    <div class="section-title">{{ 'aumico_templates_switch_accounts_dialog_initial_situation' | i18next }}</div>
    <!-- original account preview -->
    <div class="account-preview-container">
        <span class="number"> {{data.accountNumber}} </span>
        <span class="name"> {{data.accountName}} </span>
        <span class="value current"> {{data.currentValue | finNumber}} </span>
        <span class="value"> {{data.previousValue | finNumber}} </span>
    </div>
    <div class="section-title">{{ 'aumico_templates_switch_accounts_dialog_preview_output' | i18next }}</div>
    <!-- split account preview -->
    <div class="account-preview-container">
        <span class="number"> {{data.accountNumber}} </span>
        <span class="name">
            <span class="aumico-pattern-icon-check-circle">
                <i></i>
            </span>
            {{data.accountName}}
            <small>({{ 'aumico_templates_group_account_mapping_fli_type_assets' | i18next }})</small>
        </span>
        <span class="value current"> {{data.splitAccountValues.assetsClosingValue | finNumber}} </span>
        <span class="value"> {{data.splitAccountValues.assetsOpeningValue | finNumber}} </span>
    </div>
    <div class="account-preview-container">
        <span class="number">{{data.accountNumber}}</span>
        <span class="name">
            <span class="aumico-pattern-icon-check-circle">
                <i></i>
            </span>
            {{data.accountName}}
            <small>({{ 'aumico_templates_group_account_mapping_fli_type_liabilities' | i18next }})</small>
        </span>
        <span class="value current"> {{data.splitAccountValues.liabilitiesClosingValue | finNumber}} </span>
        <span class="value"> {{data.splitAccountValues.liabilitiesOpeningValue | finNumber}} </span>
    </div>

    <div class="section-title">
        {{ 'aumico_templates_switch_accounts_dialog_drop_account' | i18next }} :
        <span class="aumico-pattern-icon-check-circle">
            <i></i>
        </span>
        {{data.accountName}}
    </div>
    <div>
        <aum-select
            class="w-100"
            placeholder="{{
                            'aumico_templates_switch_accounts_dialog_selection_placeholder' | i18next 
                        }}"
            floatLabel="always"
            [aumFormControl]="parentItemSelectionFormControl"
            [options]="data.parentOptions"
            [propertyOfOptionToDisplay]="'caption'"
            [propertyOfOptionId]="'name'"
            [compareWith]="compareSelections"
        >
            <aum-form-field-label
                >{{ 'aumico_templates_switch_accounts_dialog_selection_label' | i18next }}</aum-form-field-label
            >
            <aum-form-error
                *ngIf="parentItemSelectionFormControl.errors && parentItemSelectionFormControl.errors['required']"
                >{{ 'aumico_templates_switch_accounts_dialog_error_mandatory_selection' | i18next }}
            </aum-form-error>
        </aum-select>
    </div>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="closeDialog()" color="basic">{{ 'aumico_button_cancel' | i18next }}</button>

        <button aum-button (click)="save()" [disabled]="parentItemSelectionFormControl.value == null" color="primary">
            {{ 'aumico_button_save' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
